<div class="dialogWrapper info" [ngClass]="data.type">
    <header>
        <i class="fa fa-info-circle"></i>
        <h2>{{ data.title | translate }}</h2>
    </header>
    <div class="text-body" [innerHTML]="data.body | translate | safeHtml"></div>
    <footer>
        <button class="button confirm-btn" (click)="close(true)">{{ 'generalKeywords.confirm' | translate }}</button>
        <button class="button cancel-btn" (click)="close(false)">{{ 'generalKeywords.cancel' | translate }}</button>
    </footer>
</div>
